module.exports = __webpack_public_path__ + "media/bigwin-v2-jackpot.e541f98b.webm";